import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IServiceType } from "../../utils/types/models";

export default createEntityReducer<IServiceType>(Endpoint.ServiceTypes, Endpoint.ServiceTypesList);
